import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <motion.span
    className={`block overflow-hidden pb-[0.18em] -mb-[0.18em] ${className}`}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-8% 0px" }}
  >
    <motion.span
      className="block"
      variants={{
        hidden: { y: "115%" },
        show: { y: "0%", transition: { duration: 1.1, delay, ease: EASE } },
      }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-10% 0px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);
